import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ChevronUp, RotateCcw } from "react-feather";
import ImageWithBasePath from "core/img/imagewithbasebath";
import useTableExport from "core/Operations/useTableExport";
import PropTypes from "prop-types";
const ReportTools = ({
  columns,
  data,
  fileName,
  pdfTheme = "striped",
  refresh,
  isCSV = false,
  isPdf = true,
  isPrint = true,
  refreshNeed = true,
}) => {
  const { onPrint, onCsvPrint, onExcelPrint, onPdfPrint } = useTableExport({
    columns: columns,
    data: data,
    fileName: fileName,
    pdfTheme: pdfTheme,
  });

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderPrinterTooltip = (props) => (
    <Tooltip id="printer-tooltip" {...props}>
      Printer
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  return (
    <ul className="table-top-head">
      {isPdf && (
        <li>
          <OverlayTrigger placement="top" overlay={renderTooltip}>
            <Link onClick={onPdfPrint}>
              <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
            </Link>
          </OverlayTrigger>
        </li>
      )}
      {isCSV ? (
        <li>
          <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={onCsvPrint}
            >
              <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
            </Link>
          </OverlayTrigger>
        </li>
      ) : (
        <li>
          <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={onExcelPrint}
            >
              <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
            </Link>
          </OverlayTrigger>
        </li>
      )}
      {isPrint && (
        <li>
          <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={onPrint}
            >
              <i data-feather="printer" className="feather-printer" />
            </Link>
          </OverlayTrigger>
        </li>
      )}
      {refreshNeed && (
        <li>
          <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
            <Link
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              onClick={refresh}
            >
              <RotateCcw />
            </Link>
          </OverlayTrigger>
        </li>
      )}
    </ul>
  );
};
ReportTools.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  fileName: PropTypes.string.isRequired,
  pdfTheme: PropTypes.string,
  refresh: PropTypes.func,
  isCSV: PropTypes.bool,
  isPdf: PropTypes.bool,
  isPrint: PropTypes.bool,
  refreshNeed: PropTypes.bool,
};
export default ReportTools;
